import initialStateLoader from '../initialState';

const SET_CONFIG = 'huggg/guided-choice/SET_CONFIG';
const PROCEED_TO_STEP = 'huggg/guided-choice/PROCEED_TO_STEP';
const GO_BACK = 'huggg/guided-choice/GO_BACK';

const { guidedChoice: initialState } = initialStateLoader();

const reduceToObject = array => {
  return array.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});
}

const getDefaultOrFirst = array => {
  return array.find(value => value.isDefault) ?? array[0]
}

/* Reducer - Default Export
========================================================================== */
const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {

    case SET_CONFIG:
      const initialScreen = getDefaultOrFirst(payload.configArray)
      const formattedConfig = reduceToObject(payload.configArray)
      return {
        ...state,
        config: formattedConfig,
        history: [initialScreen.id],
        previousAnswer: null,
      };

    case PROCEED_TO_STEP: {
      const updatedHistory = [...state.history];
      updatedHistory.push(payload.nextStep);
      return {
        ...state,
        history: updatedHistory,

      }
    }

    case GO_BACK: {
      const updatedHistory = [...state.history];
      updatedHistory.pop();
      return {
        ...state,
        history: updatedHistory,
      }
    }

    default:
      return state;
  }
};

export default reducer;


/* Actions
========================================================================== */
export const setConfig = configArray => dispatch => {
  dispatch({ type: SET_CONFIG, payload: { configArray } });
}
export const goBack = () => dispatch => dispatch({ type: GO_BACK });
export const proceedToTargetId = nextStep => dispatch => {
  dispatch({ type: PROCEED_TO_STEP, payload: { nextStep } });
}

/* Selectors
========================================================================== */

export const getCurrentScreen = state => {
  const { history } = state.guidedChoice ?? [];
  if (history && history.length > 0) {
    const currentId = history[history.length - 1];
    return state.guidedChoice?.config[currentId] ?? {};
  }
}

export const actions = {
  setConfig,
  goBack,
  proceedToTargetId,
  getCurrentScreen,
};
